export default "__VITE_ASSET__Dybhcoka__"